const embed = document.getElementById("embed");
const qr = document.getElementById("embed_qr");

function init(){
    // reset plattar selection on load
    if (localStorage.getItem('plattarTrack') !== null) {
        localStorage.setItem('plattarTrack', '');
    }
    // wait until viewer is loaded, then show our forms
    embed.viewer.context.setLoading = () => {
        if (window.theme.plattar.data !== null) {
            getData();
        }
    };
}

if (embed.viewer) {
    init();
} else {
  var intv = setInterval(function(){
    if (embed.viewer) {
        init();
    }
  }, 100);
}

async function getData() {
    const plattarContainer = document.querySelector('.plattar-configuration-page__container');
    const plattarWrapper = document.querySelector('[data-plattar-wrapper]');
    const plattarFormTrigger = document.querySelectorAll('[data-plattar-form-trigger]');
    const plattarSummaryBtn = document.querySelector('[data-view-summary]');
    const plattarSceneLoading = document.querySelector('[data-plattar-loading]');

    const url = window.theme.plattar.data

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const json = await response.json();
        const sceneData = json.scenes[0];
        const sceneProducts = sceneData.sceneproducts;
        const sceneMatches = json.match;

        plattarSceneLoading?.setAttribute('hidden', '');

        plattarFormTrigger?.forEach((button) => {
            button?.removeAttribute('hidden');

            button.addEventListener('click', () => {
                const summaryLinks = document.querySelector('[data-form-links]');

                plattarWrapper.toggleAttribute('hidden');
                plattarSummaryBtn?.removeAttribute('hidden');
                plattarContainer.classList.toggle('show-configuration');
                summaryLinks?.toggleAttribute('hidden');

                scrollFunction();
            });
        });

        displayConfiguration(sceneProducts, sceneMatches);
    } catch (error) {
        console.error(error.message);
    }
}

function scrollFunction() {
    const scrollToTop = document.getElementById("scroll-top");
    const scrollBottom = document.getElementById("scroll-bottom");
    const scrollDiv = document.querySelector('.scroll-to');
    const configurator = document.querySelector('.plattar-configuration-page__container');

    if (configurator.classList.contains('show-configuration')) {
        scrollDiv.classList.remove('hide');
        scrollBottom.removeAttribute('hidden');

        scrollBottom.addEventListener('click', () => {
            scrollBottom.setAttribute('hidden', '');
            scrollToTop.removeAttribute('hidden');
        });

        scrollToTop.addEventListener('click', () => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            scrollBottom.removeAttribute('hidden');
            scrollToTop.setAttribute('hidden', '');
        })

        window.onscroll = () => {
            if (document.documentElement.scrollTop < 500) {
                scrollBottom.removeAttribute('hidden');
                scrollToTop.setAttribute('hidden', '');
            } else if ( document.documentElement.scrollTop > 501) {
                scrollToTop.removeAttribute('hidden');
                scrollBottom.setAttribute('hidden', '');
            }
        };
    } else {
        scrollDiv.classList.add('hide');
    }
}

function displayConfiguration(sceneProducts, sceneMatches) {
    const plattarForm = document.querySelector('[data-plattar-form]');

    if (sceneProducts.length > 0) {
        // set and track selection
        const plattar = {
            "match": [],
            "selection": [],
        };

        // set configuration html content
        for (let i = 0; i < sceneProducts.length; i++) {
            let variantOptionDiv = '';
            let matchAttribute = '';
            let watcher = '';
            let variantTitleInit = '';
            let allMatchClass = '';
            let containerClass = '';
            const sceneProduct = sceneProducts[i];

            // set match selection
            if (sceneMatches.length > 0) {
                for (let i = 0; i < sceneMatches.length; i++) {
                    const match = sceneMatches[i];
                    if (match.type === sceneProduct.instanceTitle) {
                        matchAttribute = `data-track-match="${sceneProduct.instanceTitle}"`;

                        if (sceneProduct.product.match === 'watch') {
                            watcher = `data-watch="${sceneProduct.instanceTitle}"`;
                        }

                        const plattarMatchObj = {
                            "type": sceneProduct.instanceTitle,
                            "option": sceneProduct.product.initial,
                        }
                        plattar.match.push(plattarMatchObj);
                    }
                }
            }

            // set variant options
            for (let i = 0; i < sceneProduct.variations.length; i++) {
                const variant = sceneProduct.variations[i];
                let variantClass = "variant-option";
                let variantNoneDiv = false;

                // if variant option is None
                if (variant.match !== null && variant.match === "none" || (variant.match !== null && variant.match.length === 1 && variant.match[0].option === 'None')) {
                    variantNoneDiv = true;
                };

                if (variantNoneDiv) {
                    // optipon none should always be displayed
                    variantClass = 'variant-option variant-none';

                    if (sceneProduct.product.initial === variant.option) {
                        variantClass = 'variant-option variant-none active';
                        variantTitleInit = variant.title;

                        const plattarSelectionObj = {
                            "type": sceneProduct.instanceTitle,
                            "id": variant.id,
                            "instanceId": sceneProduct.instanceId,
                            "value": sceneProduct.product.initial,
                            "title": variant.title,
                        }
                        plattar.selection.push(plattarSelectionObj);
                    }

                } else if ((sceneProduct.product.initial === variant.option) && !variantNoneDiv) {
                    variantClass = 'variant-option active';
                    variantTitleInit = variant.title;

                    const plattarSelectionObj = {
                        "type": sceneProduct.instanceTitle,
                        "id": variant.id,
                        "instanceId": sceneProduct.instanceId,
                        "value": sceneProduct.product.initial,
                        "title": variant.title,
                    }
                    plattar.selection.push(plattarSelectionObj);

                } else if (sceneProduct.product.initial !== variant.option && variant.match !== null && !variantNoneDiv) {
                    const vMatchList = variant.match;
                    const pMatchList = plattar.match;
                    const noMatch = vMatchList.some((vMatch) => pMatchList.some((pMatch) => pMatch.type === vMatch.type && pMatch.option !== vMatch.option));

                    if (noMatch) {
                        variantClass = 'variant-option disabled';
                    };
                };

                let variantDiv = `<p class="variant-text">${variant.title}</p>`;

                if ((sceneProduct.product.type === 'img' || sceneProduct.product.type === 'colour') && !variantNoneDiv) {
                    variantDiv = `<div class="variant-image">
                                    <img src="${variant.img}" />
                                    <span class="small-text">${variant.title}</span>
                                </div>`;
                }

                variantOptionDiv += `<div class="${variantClass}" data-variant-id="${variant.id}" data-variant-option="${variant.option}" data-variant-title="${variant.title}">${variantDiv}</div>`;
            };

            // Check if all matches in one product are the same. if so,decide which to hide and show as they may be the same product but of different sizes.
            if (sceneProduct.product.match !== null && sceneProduct.product.match !== 'watch') {
                const toMatch = sceneProduct.product.match;
                const pMatchList = plattar.match;
                const noMatch = toMatch.some((vMatch) => pMatchList.some((pMatch) => pMatch.type === vMatch.type && pMatch.option !== vMatch.option));

                if (noMatch) {
                    allMatchClass = 'hide';
                }
            }

            if (sceneProduct.product.match !== null && sceneProduct.product.match !== 'watch') {
                containerClass = 'disable-none';
            };

            // set variants
            const selectId = sceneProduct.instanceTitle.toLowerCase().replace(/ /g, '_');
            let variantDiv = `
                <details class="plattar-variant-container ${sceneProduct.product.type}-variant-container ${allMatchClass} ${containerClass}">
                    <summary class="plattar-variant-title" data-title="${sceneProduct.instanceTitle}">
                        <span class="text">
                            <span>${sceneProduct.instanceTitle} - </span>
                            <span class="selection" data-selected="${variantTitleInit}">${variantTitleInit}</span>
                            <span class="preview hide"></span>
                        </span>
                        <span class="icon">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.75 6.37504C12.75 6.37504 9.61995 10.625 8.5 10.625C7.37998 10.625 4.25 6.375 4.25 6.375" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </summary>
                    <div id="${selectId}" class="plattar-variant-options" data-instance-id="${sceneProduct.instanceId}" ${matchAttribute} ${watcher}>
                        ${variantOptionDiv}
                    </div>
                </details>`;
            plattarForm.innerHTML += variantDiv;
        }

        if (location.href.includes('?map=')) {
            initPresetData(sceneProducts)
        } else {
            localStorage.setItem('plattarTrack', JSON.stringify(plattar));
            // update summary data
            launchPopup(plattar);
        }
        selectVariation(sceneProducts);
    }
}

// this is called when the dropdowns change
function selectVariation(sceneProducts) {
    const variantOption = document.querySelectorAll('.variant-option');
    const colourVariantOption = document.querySelectorAll('.colour-variant-container .variant-option');
    const plattarTrack = JSON.parse(localStorage.getItem('plattarTrack'));

    // update swtahc variant preview label
    colourVariantOption.forEach((option) => {
        option.addEventListener('mouseover', () => {
            const selectionTitle = option.getAttribute('data-variant-title');
            const instanceTitle = option.parentNode.parentElement.querySelector(`.plattar-variant-title`).getAttribute('data-title');
            const previewDiv = document.querySelector(`.plattar-variant-title[data-title="${instanceTitle}"] .preview`);
            const titleDiv = document.querySelector(`.plattar-variant-title[data-title="${instanceTitle}"] .selection`);

            previewDiv.classList.remove('hide');
            titleDiv.classList.add('hide');
            previewDiv.innerHTML = selectionTitle;
        });

        option.addEventListener('mouseout', () => {
            const instanceTitle = option.parentNode.parentElement.querySelector(`.plattar-variant-title`).getAttribute('data-title');
            const previewDiv = document.querySelector(`.plattar-variant-title[data-title="${instanceTitle}"] .preview`);
            const titleDiv = document.querySelector(`.plattar-variant-title[data-title="${instanceTitle}"] .selection`);

            previewDiv.classList.add('hide');
            titleDiv.classList.remove('hide');
        });
    });

    variantOption.forEach((option) => {
        option.addEventListener('click', () => {
            const selection = option.getAttribute('data-variant-id');
            const selectionValue = option.getAttribute('data-variant-option');
            const selectionTitle = option.getAttribute('data-variant-title');
            const sceneProductID = option.parentElement.getAttribute('data-instance-id');
            const trackMatch = option.parentElement.hasAttribute('data-track-match');
            const watchMatchValue = option.parentElement.getAttribute('data-watch');
            const instanceTitle = option.parentNode.parentElement.querySelector(`.plattar-variant-title`).getAttribute('data-title');
            const titleDiv = document.querySelector(`.plattar-variant-title[data-title="${instanceTitle}"] .selection`);

            // update active variants class
            option.parentElement.querySelector('.active')?.classList.remove('active');
            option.classList.add('active');

            // reset selected option preview
            titleDiv.setAttribute('data-selected', selectionTitle);
            titleDiv.innerHTML = selectionTitle;

            // update all selected variants to match the size
            if (trackMatch) {
                resetPlattarData(selectionValue, sceneProducts, plattarTrack, option, watchMatchValue);
            } else {
                const foundIndex = plattarTrack.selection.findIndex(x => x.instanceId == sceneProductID);

                plattarTrack.selection[foundIndex].id = selection;
                plattarTrack.selection[foundIndex].value = selectionValue;
                plattarTrack.selection[foundIndex].title = selectionTitle;

                localStorage.setItem('plattarTrack', JSON.stringify(plattarTrack))

                // update summary data
                launchPopup(plattarTrack);

                // update 3d viewer
                selectedCode(sceneProductID, selection);
            }
        });
    });
}

function selectedCode(sceneProductID, variantID) {
     // perform selection in the Plattar Viewer
     embed.viewer.messenger.selectSceneProductVariation(sceneProductID, variantID).then(() => {
        embed.viewer.messenger.getSceneGraphID()
        .then((sceneGraphId) => {
            qr.setAttribute('scene-graph-id', sceneGraphId);
        });
    }).catch((err) => {
        console.error(err);
    });
}

function resetPlattarData(selectionValue, sceneProducts, plattarTrack, selectedOption, watchMatchValue) {
    // update selected option match list
    const productMatch = selectedOption.parentElement.getAttribute('data-track-match');
    const matchIndex = plattarTrack.match.findIndex((x) => x.type === productMatch);
    const selectionIndex = plattarTrack.selection.findIndex((x) => x.type === productMatch);
    const initTrackOption = plattarTrack.match[matchIndex].option;

    plattarTrack.match[matchIndex].type = productMatch;
    plattarTrack.match[matchIndex].option = selectionValue;

    // update selected option selection list
    const selectedValue = selectedOption.getAttribute('data-variant-option');
    const selectedTitle = selectedOption.getAttribute('data-variant-title');
    const selectedID = selectedOption.getAttribute('data-variant-id');

    plattarTrack.selection[selectionIndex].id = selectedID;
    plattarTrack.selection[selectionIndex].title = selectedTitle;
    plattarTrack.selection[selectionIndex].value = selectedValue;

    displayPlattarData(sceneProducts, plattarTrack, selectionValue, productMatch, initTrackOption, watchMatchValue);
}

function displayPlattarData(sceneProducts, plattarTrack, selectionValue, productMatch, initTrackOption, watchMatchValue) {
    for (let i = 0; i < sceneProducts.length; i++) {
        const sceneProduct = sceneProducts[i];
        const pMatchList = plattarTrack.match;
        const toMatch = sceneProduct.product.match;
        let ignoreVariant = false;

        // Check if all matches in one product are the same. if so,decide which to hide and show as they may be the same product but of different sizes.
        if (sceneProduct.product.match !== null && sceneProduct.product.match !== 'watch') {
            const matchIndex = toMatch.some((v) => pMatchList.some((pMatch) => pMatch.type === v.type && pMatch.option === v.option));
            const noMatchIndex = toMatch.some((v) => pMatchList.some((pMatch) => pMatch.type === v.type && pMatch.option !== v.option));
            const productDiv = document.querySelector(`.plattar-variant-title[data-title="${sceneProduct.instanceTitle}"]`).parentElement;

            if ((matchIndex && noMatchIndex) || (!matchIndex && noMatchIndex)) {
                productDiv.classList.add('hide');
                ignoreVariant = true;
            } else if (matchIndex && !noMatchIndex) {
                productDiv.classList.remove('hide');
            }
        }

        // set variant options
        if (sceneProduct.variations.length > 0) {
            for (let i = 0; i < sceneProduct.variations.length; i++) {
                const variant = sceneProduct.variations[i];
                const vMatchList = variant.match;
                const variantDiv = document.querySelector(`.variant-option[data-variant-id="${variant.id}"]`);
                const variantTrackDiv = variantDiv.parentElement.hasAttribute('data-track-match');
                const variantWatchDiv = variantDiv.parentElement.hasAttribute('data-watch');
                const trackIndex = plattarTrack.selection.findIndex(x => x.instanceId === sceneProduct.instanceId);

                let variantNoneDiv = false; // none option
                let keepNoneDiv = false; // maintain none as active variant
                let vAllMatch = false; // mainly for brackets, check if all variant match, matches

                // if variant option is None
                if (variant.match !== null && variant.match !== "none" && (variant.match !== null && variant.match.length === 1 && variant.match[0].option === 'None')) {
                    variantNoneDiv = vMatchList.some((x) => x.type === productMatch && x.option === 'None');
                    keepNoneDiv = vMatchList.some((x) => x.type !== productMatch && x.option === 'None');
                }

                if (selectionValue !== null && productMatch !== null && !ignoreVariant && sceneProduct.product.match !== null && sceneProduct.product.match !== 'watch' && variant.match !== null) {
                    let vMatch = 0;

                    vMatchList.forEach((v) => {
                        if (v.option !== 'None') {
                            const checkAll = plattarTrack.match.filter((x) => x.type === v.type && x.option === v.option);

                            if (checkAll.length !== 0) {
                                vMatch += 1;
                            }
                        }
                    });

                    vAllMatch = vMatch === vMatchList.length;
                }

                // If product stands alone , load from share link
                if (selectionValue === null && (sceneProduct.product.match === null || sceneProduct.product.match === 'watch') && (variant.match === null || variant.match === 'none')) {
                    const singleProductIndex =  plattarTrack.selection.findIndex((x) => x.type === sceneProduct.instanceTitle && x.instanceId === sceneProduct.instanceId);
                    const singleProductDiv = document.querySelector(`[data-instance-id="${sceneProduct.instanceId}"] .variant-option[data-variant-option="${plattarTrack.selection[singleProductIndex].value}"][data-variant-id="${plattarTrack.selection[singleProductIndex].id}"]`);

                    if (!singleProductDiv.classList.contains('active')) {
                        document.querySelector(`[data-instance-id="${sceneProduct.instanceId}"] .variant-option.active`).classList.remove('active');
                        singleProductDiv.classList.add('active');
                    }

                    const singleProductTitleDiv = document.querySelector(`.plattar-variant-title[data-title="${sceneProduct.instanceTitle}"] .selection`);

                    // reset selected option preview
                    singleProductTitleDiv.setAttribute('data-selected', plattarTrack.selection[singleProductIndex].title);
                    singleProductTitleDiv.innerHTML = plattarTrack.selection[singleProductIndex].title;
                }

                if (variantTrackDiv && (variant.match !== null && variant.match !== "none" && variant.match !== "None") && sceneProduct.instanceTitle !== productMatch && selectionValue !== null) {
                    const vTrackMatch = vMatchList.some((v) => v.type === productMatch);

                    if (vTrackMatch) {
                        const activateMatch = vMatchList?.some((v) => v.type === productMatch && v.option === selectionValue);
                        const vTrackNWatchSelection = plattarTrack.selection.filter((p) => p.instanceId === sceneProduct.instanceId);
                        const notRelated = vMatchList.some((v) => v.type === productMatch && v.option !== selectionValue);
                        const related = vMatchList.some((v) => v.type === productMatch && v.option === selectionValue);

                        if (notRelated) {
                            // check which object in the match array the selected option matches
                            if (variantDiv.classList.contains('active')) {
                                variantDiv.classList.remove('active');
                            }
                            variantDiv.classList.add('disabled');
                        } else if (related && variantDiv.classList.contains('disabled')) {
                            variantDiv.classList.remove('disabled');
                        }

                        // Reset tracker that also relies on other tracker
                        if (activateMatch && vTrackNWatchSelection.length > 0 && vTrackNWatchSelection[0].title === variant.title && variant.option !== 'None') {
                            const vTrackNWatchMatchIdx = plattarTrack.match.findIndex((p) => p.type === sceneProduct.instanceTitle);

                            // update selected option selection list
                            plattarTrack.match[vTrackNWatchMatchIdx].option = variant.option;

                            // update active variants class
                            if (variantDiv.classList.contains('disabled')) {
                                variantDiv.classList.remove('disabled');
                            }

                            updatePlattarTrack(plattarTrack, variant, variant.id, variant.option, variant.title, true, sceneProduct.instanceTitle, sceneProduct.instanceId);
                        }
                    }
                }

                // If div is a watcher, tracker plus requires updates and did not activate on change value
                if (variantWatchDiv && productMatch !== null && selectionValue !== null && selectionValue === variant.option) {
                    const vTrackNWatchMatchIdx = plattarTrack.match.findIndex((p) => p.type === sceneProduct.instanceTitle);

                    // update selected option selection list
                    plattarTrack.selection[trackIndex].title = variant.title;
                    plattarTrack.selection[trackIndex].id = variant.id;
                    plattarTrack.selection[trackIndex].value = variant.option;

                    plattarTrack.match[vTrackNWatchMatchIdx].option = variant.option;

                    // update 3d viewer
                    selectedCode(sceneProduct.instanceId, variant.id);
                }

                if (variantNoneDiv && productMatch !== null) {
                    const foundIndex = plattarTrack.selection.findIndex(x => x.instanceId === sceneProduct.instanceId);
                    const sceneProductMatch = sceneProduct.product.match !== null && sceneProduct.product.match !== 'watch' ? sceneProduct.product.match?.some(x => x.option === initTrackOption) : false;
                    const setNone = vMatchList.some((x) => x.option === 'None' && (initTrackOption !== null && !variantTrackDiv) && sceneProductMatch);

                    // If product should be hidden, set to none
                    if (selectionValue !== null && ignoreVariant && variant.option === 'None') {
                        // update active variants class
                        if (variantDiv.classList.contains('disabled')) {
                            variantDiv.classList.remove('disabled');
                        }

                        updatePlattarTrack(plattarTrack, variant, variant.id, variant.option, variant.title, true, sceneProduct.instanceTitle, sceneProduct.instanceId);
                    }

                    // If none, remove other selections or if selected a different range or products, set the rest to none under the same category
                    if ((initTrackOption !== null && !variantTrackDiv && setNone) || (selectionValue === 'None' && plattarTrack.selection[foundIndex].instanceId === sceneProduct.instanceId)) {
                        // update active variants class
                        if (variantDiv.classList.contains('disabled')) {
                            variantDiv.classList.remove('disabled');
                        }
                        updatePlattarTrack(plattarTrack, variant, variant.id, variant.option, variant.title, true, sceneProduct.instanceTitle, sceneProduct.instanceId);
                    }

                    // Skip none for current option
                    if (selectionValue !== null && variant.option === 'None' && variantDiv.classList.contains('active') && !variantTrackDiv) {
                        const checkCurrentNone = sceneProduct.product.match !== null && sceneProduct.product.match !== 'watch' ? sceneProduct.product.match.some((x) => x.option === selectionValue && x.type === productMatch) : false;

                        if (checkCurrentNone) {
                            variantDiv.classList.remove('active');
                        }

                        // update dropdown selection title
                        const titleDiv = document.querySelector(`.plattar-variant-title[data-title="${sceneProduct.instanceTitle}"] .selection`);

                        // reset selected option preview
                        titleDiv.setAttribute('data-selected', variant.title);
                        titleDiv.innerHTML = variant.title;

                        // update 3d viewer
                        selectedCode(sceneProduct.instanceId, variant.id);
                    }

                } else if (((selectionValue !== variant.option) || selectionValue === null) && (variant.match !== null && variant.match !== "none") && !variantNoneDiv) {
                    const matchVariant = vMatchList.some((vMatch) => pMatchList.some((pMatch) => pMatch.type === vMatch.type && pMatch.option === vMatch.option));
                    const diableVariant = vMatchList.some((vMatch) => pMatchList.some((pMatch) => pMatch.type === vMatch.type && pMatch.option !== vMatch.option));
                    const vTrackMatch = vMatchList.some((v) => v.type === productMatch);

                    // If data came from share link, and variant selected is not None, remove active class
                    if (selectionValue === null && variantDiv.classList.contains('active')) {
                        const currValue = variantDiv.getAttribute('data-variant-option');
                        const currId = variantDiv.getAttribute('data-variant-id');
                        const noneDiv =  plattarTrack.selection.some((x) => x.value === 'None' && x.instanceId === sceneProduct.instanceId && x.id === currId && currValue === 'None');
                        const currDiv =  plattarTrack.selection.some((x) => x.value !== currValue && x.instanceId === sceneProduct.instanceId && x.id !== currId);
                        const currIndex =  plattarTrack.selection.findIndex((x) => x.value !== currValue && x.instanceId === sceneProduct.instanceId && x.id !== currId);

                        variantDiv.classList.remove('active');

                        if (noneDiv) {
                            variantDiv.classList.add('active');
                        }

                        if (currDiv && !variantDiv.classList.contains('active')) {
                            document.querySelector(`.variant-option[data-variant-id="${plattarTrack.selection[currIndex].id}"]`).classList.add('active');
                            const titleDiv = document.querySelector(`.plattar-variant-title[data-title="${sceneProduct.instanceTitle}"] .selection`);
                            // reset selected option preview
                            titleDiv.setAttribute('data-selected', plattarTrack.selection[currIndex].title);
                            titleDiv.innerHTML = plattarTrack.selection[currIndex].title;
                        }
                    }

                    // check which object in the match array the selected option matches under tracked variant
                    if (variantTrackDiv && vTrackMatch && sceneProduct.instanceTitle !== productMatch && selectionValue !== null) {
                        if (variantDiv.classList.contains('active')) {
                            variantDiv.classList.remove('active');
                        }
                        variantDiv.classList.add('disabled');
                    }

                    if (
                        (matchVariant && diableVariant && !keepNoneDiv && ((!variantTrackDiv && selectionValue !== null) || (selectionValue === null))) ||
                        (!matchVariant && diableVariant && !keepNoneDiv && ((!variantTrackDiv && selectionValue !== null) || (selectionValue === null)))
                    ) {
                        if (variantDiv.classList.contains('active')) {
                            variantDiv.classList.remove('active');
                        }
                        variantDiv.classList.add('disabled');

                    } else if (matchVariant && !diableVariant) {
                        const foundIndex = plattarTrack.selection.findIndex(x => x.instanceId === sceneProduct.instanceId);
                        const sceneProductMatch = sceneProduct.product.match !== null && sceneProduct.product.match !== 'watch' ? sceneProduct.product.match?.some(x => x.option === selectionValue) : false;

                        if (variantDiv.classList.contains('disabled')) {
                            variantDiv.classList.remove('disabled');
                        }

                        // If product is to be tracked but also updated if changes in other tracked products are made
                        if (selectionValue !== null && variantTrackDiv && vTrackMatch) {
                            const activateMatch = vMatchList.some((v) => v.type === productMatch && v.option === selectionValue);
                            const vTrackNWatchSelection = plattarTrack.selection.filter((p) => p.instanceId === sceneProduct.instanceId);

                            // get the plattar track selection to update values for variant track match, then check bracket updates
                            if (activateMatch && vTrackNWatchSelection.length > 0 && vTrackNWatchSelection[0].title === variant.title && variant.option !== 'None') {
                                const vTrackNWatchMatchIdx = plattarTrack.match.findIndex((p) => p.type === sceneProduct.instanceTitle);

                                // update selected option selection list
                                plattarTrack.match[vTrackNWatchMatchIdx].option = variant.option;

                                // update active variants class
                                if (variantDiv.classList.contains('disabled')) {
                                    variantDiv.classList.remove('disabled');
                                }
                                updatePlattarTrack(plattarTrack, variant, variant.id, variant.option, variant.title, true, sceneProduct.instanceTitle, sceneProduct.instanceId);
                            }
                        }

                        // If selected a different range or products, set the rest to first option under the same category
                        if (selectionValue !== null && !variantTrackDiv && sceneProductMatch) {
                           const activeDivIndex =  document.querySelectorAll(`.plattar-variant-options[data-instance-id="${sceneProduct.instanceId}"] .variant-option:not(.variant-none):not(.disabled)`)[0];
                           const activeDivId = activeDivIndex.getAttribute('data-variant-id');

                            if (variant.id === activeDivId && variant.option !== 'None') {
                                // update active variants class
                                if (variantDiv.classList.contains('disabled')) {
                                    variantDiv.classList.remove('disabled');
                                }
                                updatePlattarTrack(plattarTrack, variant, variant.id, variant.option, variant.title, true, sceneProduct.instanceTitle, sceneProduct.instanceId);
                            }
                        }

                        // update the selection to the latest value and activate it
                        const matchRelevant = vMatchList.some((v) => v.type === watchMatchValue);
                        const matchNotNone = pMatchList.some((p) => matchRelevant && p.value !== 'None');
                        if (plattarTrack.selection[foundIndex].instanceId === sceneProduct.instanceId &&
                            (plattarTrack.selection[foundIndex].title === variantDiv.getAttribute('data-variant-title')
                            || (watchMatchValue !== null && plattarTrack.selection[foundIndex].title !== variantDiv.getAttribute('data-variant-title') && matchRelevant && !matchNotNone))) {
                            const variantID = variantDiv.getAttribute('data-variant-id');
                            updatePlattarTrack(plattarTrack, variant, variantID, variantDiv.getAttribute('data-variant-option'), variantDiv.getAttribute('data-variant-title'), selectionValue, sceneProduct.instanceTitle, sceneProduct.instanceId);

                            // update 3d viewer
                            selectedCode(sceneProduct.instanceId, variantID);
                        }
                    }

                } else if (vAllMatch) {
                    const checkVMatchSelected = vMatchList.some((x) => x.type === productMatch && x.option === selectionValue);
                    const checkPlattarTrackSelected = plattarTrack.selection.some((p) => p.instanceId === sceneProduct.instanceId && p.value !== variant.option);

                    // If does not match what was selected but should be updated
                    if (checkVMatchSelected && checkPlattarTrackSelected) {
                        const variantID = variantDiv.getAttribute('data-variant-id');
                        updatePlattarTrack(plattarTrack, variant, variantID, variantDiv.getAttribute('data-variant-option'), variantDiv.getAttribute('data-variant-title'), selectionValue, sceneProduct.instanceTitle, sceneProduct.instanceId);

                        // update 3d viewer
                        selectedCode(sceneProduct.instanceId, variantID);
                    }
                }
            }
        }
    }

    localStorage.setItem('plattarTrack', JSON.stringify(plattarTrack));
    // update summary data
    launchPopup(plattarTrack);
}

function updatePlattarTrack(plattarTrack, variant, variantID, variantValue, variantTitle, updateTitle, instanceTitle, instanceId) {
    const foundIndex = plattarTrack.selection.findIndex(x => x.instanceId === instanceId);

     // update selected option selection list
    plattarTrack.selection[foundIndex].title = variantTitle;
    plattarTrack.selection[foundIndex].id = variantID;
    plattarTrack.selection[foundIndex].value = variantValue;

    // update active variants class
    const activeDiv = document.querySelector(`.variant-option[data-variant-option="${variantValue}"][data-variant-id="${variantID}"]`);
    if (activeDiv.classList.contains('disabled')) {
        activeDiv.classList.remove('disabled');
    }
    activeDiv?.classList.add('active');

    // if it is onload from a shared link and needs updating
    if (updateTitle || updateTitle === null) {
        const titleDiv = document.querySelector(`.plattar-variant-title[data-title="${instanceTitle}"] .selection`);

        // reset selected option preview
        titleDiv.setAttribute('data-selected', variant.title);
        titleDiv.innerHTML = variant.title;
    }
}

function launchPopup(plattarTrack) {
    const summaryPopup = document.querySelector('[data-summary-popup]');

    if (summaryPopup) {
        const summaryDiv = document.querySelector('[data-plattar-summary]');
        const summaryBtn = document.querySelector('[data-quote-trigger]');
        const summaryCloseBtn = document.querySelectorAll('[data-summary-close]');
        const quoteName = document.querySelector('[data-name]');

        let selectedDiv = '';
        let selectedInput = '';
        summaryDiv.innerHTML = '';

        summaryBtn.addEventListener('click', () => {
            document.querySelector(':root').classList.add('plattar-popup-active');
            summaryPopup?.removeAttribute('hidden');
            summaryPopup.querySelector('form')?.reset();
        });

        summaryCloseBtn.forEach((btn) => {
            btn.addEventListener('click', () => {
                document.querySelector(':root').classList.remove('plattar-popup-active');
                summaryPopup?.setAttribute('hidden', '');
            });
        });

        let selectionIds = [];
        plattarTrack.selection.forEach((selection) => {
            if (selection.value !== 'None') {
                selectedDiv += `<p class="plattar__summary-option"><span class="title">${selection.type}: </span><span>${selection.title}</span></p>`;
                selectedInput += `${selection.type}: ${selection.title}\n`;
            }
            selectionIds.push(selection.id);
        });
        // qr.setAttribute('variation-id', selectionIds.join(','));

        quoteName?.addEventListener('change', (e) => {
            e.target.form[1].value = selectedInput;
        });

        summaryDiv.innerHTML += selectedDiv;

        // update configuration state
        setConfigState();
    }
}

// this sets the configuration state for the user
function setConfigState() {
    const plattarConfig = localStorage.getItem('plattarTrack');
    const shareInput = document.querySelector('[data-share-url]');
    const shareButton = document.querySelector('[data-share-button]');

    let mapstring = btoa(plattarConfig);
    let shareURL = '';

    embed.setAttribute('config-state', mapstring);

    if (location.href.includes('?map=')) {
        shareURL = location.href.split('?map=')[0] + '?map=' + mapstring;
    } else {
        shareURL = location.href + '?map=' + mapstring;
    }

    // add link to quote
    const quoteForm = document.querySelector('[data-quote-form]');
    if (quoteForm) {
        const quoteShare = document.querySelector('[data-share-link]');
        quoteShare.setAttribute('value', encodeURI(shareURL));
    }

    shareInput.setAttribute('value', shareURL);
    shareButton.setAttribute('href', encodeURI(shareURL))

    // Copy link to clipboard
    // shareInput.addEventListener('click', async () => {
    //     try {
    //         await navigator.clipboard.writeText(encodeURI(shareURL));
    //     } catch (err) {
    //         console.error('Failed to copy: ', err);
    //     }
    // });

    document.querySelector('[data-ar-trigger]').addEventListener('click', () => {
        launchAR();
    });
    renderQRCode();

}

function initPresetData(sceneProducts) {
    // Update state if it came from a share url
    let urlString = location.search.split('?map=')[1];
    let map = atob(urlString);
    map = JSON.parse(map);

    map.selection.forEach((selection) => {
        selectedCode(selection.instanceId, selection.id);
    })
    displayPlattarData(sceneProducts, map, null, null, null, null);
}

// this will attempt to launch AR Mode
// if on desktop, a QR Code will be rendered instead
function launchAR() {
    // first, we re-set the previously saved configuration state

    // then, we try to launch AR Mode if available
    if (PlattarARAdapter.Util.canAugment()) {
        qr.startAR().then(() => {
            // nada
        }).catch((err) => {
            renderQRCode();
        });
    } else {
        // fallback to rendering QR Code
        renderQRCode();
    }
}

// this will render a QR Code that takes the user to a specified
// configuration
function renderQRCode() {
    qr.startQRCode().then(() => {
        // nada
    }).catch((err) => {
        console.error(err);
    });
}

